module.exports = __webpack_public_path__ + "img/favicon.fb200ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.png
// module id = 1H3f
// module chunks = 2